import React, { useMemo } from 'react'

import { BodyText, Link } from '@paypalcorp/pp-react'
import styles from './AiSearch.module.css'

/* Note: As the react mardown package is ESM only. using require to import the module 
https://github.com/remarkjs/react-markdown#install
*/
const Markdown = require('react-markdown').default

const MarkdownContainer = ({ answerId, searchID, seeMore, answerSummary }) => {
  const fptiData = typeof window !== `undefined` && window.fpti

  // On click handler for link in AI answer
  const answerLinkClick = (linkProps) => {
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          name: 'gen_ai_summary',
          tag: 'ai-summary-link-clicked',
          link_name: 'ai-summary-link-clicked',
          link: linkProps.href,
          answerId,
          component: 'devdiscoverynodeweb',
          firstPageResult: true,
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
  }
  const renderMarkDown = () => {
    return (
      <Markdown
        components={{
          a: ({ href, ...linkProps }) => (
            <Link
              onClick={() => answerLinkClick(linkProps)}
              href={`${href}?gen_ai_summary=true&search_id=${searchID}`}
              {...linkProps}
              target="_blank"
            />
          ),
        }}
      >
        {answerSummary}
      </Markdown>
    )
  }
  return (
    <BodyText
      className={`${styles.answerSummary} ${
        !seeMore ? undefined : styles.clampContainer
      }`}
    >
      {useMemo(() => renderMarkDown(), [answerSummary])}
    </BodyText>
  )
}

export default MarkdownContainer
